// extracted by mini-css-extract-plugin
export default {"wrapper":"home_wrapper__FWptB","container":"home_container__BgDW7","col":"home_col__sQfpm","home__card":"home_home__card__O0WVG"};